import { Component, computed, CUSTOM_ELEMENTS_SCHEMA, input } from '@angular/core';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'app-table-date-cell',
    templateUrl: './table-date-cell.component.html',
    imports: [DatePipe],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class TableDateCellComponent {
    public date = input<Date | string | null | undefined>();

    protected readonly uid = crypto.randomUUID();

    protected readonly relativeTime = computed(() => {
        const d = this.date();
        if (!d) return '';

        const now = new Date();
        const diffMs = now.getTime() - new Date(d).getTime();
        const diffMinutes = Math.floor(diffMs / 60_000);
        const diffHours = Math.floor(diffMs / 3_600_000);
        const diffDays = Math.floor(diffMs / 86_400_000);
        const diffMonths = Math.floor(diffDays / 30);

        const rtf = new Intl.RelativeTimeFormat('en', { numeric: 'auto' });

        if (diffMinutes < 60) {
            return rtf.format(-diffMinutes, 'minute');
        } else if (diffHours < 24) {
            return rtf.format(-diffHours, 'hour');
        } else if (diffDays < 30) {
            return rtf.format(-diffDays, 'day');
        } else {
            return rtf.format(-diffMonths, 'month');
        }
    });
}
